import { render, staticRenderFns } from "./V2DealPackCard.vue?vue&type=template&id=75fc2ad5&scoped=true&"
import script from "./V2DealPackCard.vue?vue&type=script&lang=js&"
export * from "./V2DealPackCard.vue?vue&type=script&lang=js&"
import style0 from "./V2DealPackCard.vue?vue&type=style&index=0&id=75fc2ad5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fc2ad5",
  null
  
)

export default component.exports